import React from "react";
import envVariables from "../../data/envVariables";

const PortalPricesEmbed = ({ legId }) => {
    if (!legId) return null;
    const src = `${envVariables.documentBase}/prices/Readonly?lo=${encodeURIComponent(legId)}`;

    return (
        <section className="portal-prices-embed wrap wrap--sm-no-padding" aria-label="Prices (read only)">
            <div className="portal-prices-embed__header">
                <h3 className="portal-prices-embed__title">Prices</h3>
                <span className="portal-prices-embed__badge">Read only</span>
            </div>
            <div className="portal-prices-embed__frame-wrap">
                <iframe className="portal-prices-embed__frame" src={src} title="Prices (read only)" loading="lazy" />
            </div>
        </section>
    );
};

export default PortalPricesEmbed;
